export const expiryTime = 30; // seconds
